export const GET_QUOTEBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    quoteBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      ivImage
      quoteText{json}
      quoteSource
      linkReference {
        globalLinkItem
        url
        linkText
        variant
        reference {
          ... on Page {
            content {
              __typename
            }
            slug
          }
          ... on FileBlock {
            imageVaultFile
            __typename
          }
        }
      }
    }
  }
`;
